import React, { useState, useEffect, useRef } from "react";
import "@/App.css";
import axios from "axios";
import { 
  Star, 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Award, 
  Users, 
  Car, 
  CheckCircle, 
  MessageCircle,
  ChevronRight,
  Menu,
  X,
  Trophy,
  Home,
  BookOpen,
  MapPinned,
  Sparkles,
  Quote,
  Send,
  GraduationCap,
  Shield,
  Calendar,
  Coins,
  ClipboardList,
  UserCheck,
  Gift
} from "lucide-react";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Textarea } from "./components/ui/textarea";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "./components/ui/select";
import { Toaster, toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/nyct9ka3_WhatsApp%20Image%202026-03-24%20at%2021.12.58.jpeg";
const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/6c067fc9-6d7b-4a5b-bc59-0481b335ce60/images/740084a4c396293b3251c7dc65708c38775a575b4bd76a7c17c492104bacb98e.png";
const ABOUT_IMG = "https://static.prod-images.emergentagent.com/jobs/6c067fc9-6d7b-4a5b-bc59-0481b335ce60/images/9938b18de6d3f5bddd780a83438a9fe37365bd4f5f3858fc7afd330ff83e4a36.png";
const CONFETTI_BG = "https://static.prod-images.emergentagent.com/jobs/6c067fc9-6d7b-4a5b-bc59-0481b335ce60/images/73fe35650c4263560c4625ffa0f42f2de127ab75ad42d833a9598c65abd9d3fb.png";

// Pass student images - All 12 student photos
const PASS_STUDENTS = [
  { id: 1, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/a8i2ethb_WhatsApp%20Image%202026-03-24%20at%2021.12.57.jpeg", name: "Student 1" },
  { id: 2, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/j29j5ft4_WhatsApp%20Image%202026-03-24%20at%2021.12.57%20%282%29.jpeg", name: "Student 2" },
  { id: 3, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/o59jnlg8_WhatsApp%20Image%202026-03-24%20at%2021.12.57%20%283%29.jpeg", name: "Student 3" },
  { id: 4, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/bsa5d9py_WhatsApp%20Image%202026-03-24%20at%2021.12.57%20%284%29.jpeg", name: "Student 4" },
  { id: 5, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/n8diy4dj_WhatsApp%20Image%202026-03-24%20at%2021.12.55%20%281%29.jpeg", name: "Student 5" },
  { id: 6, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/bnhjvnfx_WhatsApp%20Image%202026-03-24%20at%2021.12.55%20%282%29.jpeg", name: "Student 6" },
  { id: 7, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/viboyp6w_WhatsApp%20Image%202026-03-24%20at%2021.12.55%20%285%29.jpeg", name: "Student 7" },
  { id: 8, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/fdg937ba_WhatsApp%20Image%202026-03-24%20at%2021.12.55%20%286%29.jpeg", name: "Student 8" },
  { id: 9, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/l82pin6q_WhatsApp%20Image%202026-03-24%20at%2021.12.55%20%287%29.jpeg", name: "Student 9" },
  { id: 10, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/q0fupmot_WhatsApp%20Image%202026-03-24%20at%2021.12.56%20%284%29.jpeg", name: "Student 10" },
  { id: 11, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/x31ya667_WhatsApp%20Image%202026-03-24%20at%2021.12.56%20%281%29.jpeg", name: "Student 11" },
  { id: 12, image: "https://customer-assets.emergentagent.com/job_learn-to-drive-47/artifacts/ztybhltd_WhatsApp%20Image%202026-03-24%20at%2021.12.56%20%2811%29.jpeg", name: "Student 12" },
];

// Testimonials data
const TESTIMONIALS = [
  {
    id: 1,
    name: "Gabriella",
    text: "I had an excellent experience with Khan. His patience and genuine belief in my abilities made the learning process enjoyable and stress-free. He taught me everything I needed to know with clarity and encouragement. I highly recommend him to anyone looking for a supportive and skilled driving instructor!",
    rating: 5
  },
  {
    id: 2,
    name: "Noman",
    text: "He managed the short time very well and trained me to the level that I got my much needed driving licence within 6 weeks. His teaching methodology is excellent and focuses on building confidence alongside technical skills.",
    rating: 5
  },
  {
    id: 3,
    name: "Ella",
    text: "My instructor made the learning process quite simple. Taught everything precisely but in chunks enabling me to pass very first time. The structured approach and patient guidance made all the difference. Highly recommended!",
    rating: 5
  }
];

// Courses data
const COURSES = [
  {
    id: 1,
    title: "Single Lessons",
    price: "£40",
    unit: "per hour",
    description: "Perfect for learners who want flexible scheduling",
    features: ["1-hour sessions", "Pay as you go", "Flexible scheduling", "Personalised feedback"]
  },
  {
    id: 2,
    title: "Block Bookings",
    price: "£350",
    unit: "10 hours",
    description: "Save more with our popular block booking package",
    features: ["10 hours of tuition", "Save £50 overall", "Priority booking", "Progress tracking"],
    popular: true
  },
  {
    id: 3,
    title: "Intensive Courses",
    price: "£750",
    unit: "20 hours",
    description: "Fast-track your way to passing",
    features: ["20 hours over 1-2 weeks", "Intensive practice", "Test preparation", "Mock tests included"]
  },
  {
    id: 4,
    title: "Pass Plus",
    price: "£200",
    unit: "6 hours",
    description: "Enhance your driving skills post-test",
    features: ["6-hour course", "Insurance discounts", "Motorway driving", "Night driving skills"]
  }
];

// Areas data
const AREAS = ["Slough", "Windsor", "Old Windsor", "Maidenhead", "Egham", "Langley", "Iver", "Datchet"];

// USPs data
const USPS = [
  { icon: Award, title: "Grade A Driving Instructor", description: "Highest DVSA grading for exceptional teaching quality", highlight: true },
  { icon: Trophy, title: "High Pass Rate", description: "Our students consistently achieve first-time passes" },
  { icon: Home, title: "Pick Up Service", description: "Convenient collection from home or work" },
  { icon: ClipboardList, title: "DVSA Aligned Syllabus", description: "Structured lessons with test route practice" },
  { icon: MapPin, title: "Local Area Expertise", description: "All SL postcodes covered with local knowledge" },
  { icon: Coins, title: "Transparent Pricing", description: "Single lessons, blocks & intensives - no hidden fees" },
  { icon: Calendar, title: "Flexible Scheduling", description: "Evenings and weekends available" },
  { icon: BookOpen, title: "Detailed Feedback", description: "Actionable improvement tips after every lesson" },
  { icon: Gift, title: "Referral Discounts", description: "Recommend friends for exclusive savings" }
];

// Navigation links
const NAV_LINKS = [
  { href: "#home", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#why-us", label: "Why Us" },
  { href: "#areas", label: "Areas" },
  { href: "#pass-students", label: "Our Pass Students" },
  { href: "#testimonials", label: "Testimonials" },
  { href: "#contact", label: "Contact" }
];

// Header Component
const Header = ({ scrolled, mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <header 
      data-testid="header"
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-xl shadow-lg py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-3" data-testid="logo-link">
          <img 
            src={LOGO_URL} 
            alt="Abbott Drives" 
            className="h-20 md:h-24 w-auto object-contain"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-semibold transition-colors ${
                scrolled ? 'text-[#0A192F] hover:text-[#F59E0B]' : 'text-white hover:text-[#F59E0B]'
              }`}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden lg:block">
          <a href="#contact">
            <Button 
              className="bg-[#F59E0B] text-[#0A192F] hover:bg-[#D97706] hover:text-white font-bold px-6 py-2 rounded-none"
              data-testid="book-lesson-btn"
            >
              Book a Lesson
            </Button>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="lg:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-btn"
        >
          {mobileMenuOpen ? (
            <X className={scrolled ? 'text-[#0A192F]' : 'text-white'} size={28} />
          ) : (
            <Menu className={scrolled ? 'text-[#0A192F]' : 'text-white'} size={28} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" data-testid="mobile-menu">
          <button 
            className="absolute top-6 right-6 z-[110] p-2"
            onClick={() => setMobileMenuOpen(false)}
            data-testid="mobile-menu-close-btn"
          >
            <X className="text-white" size={32} />
          </button>
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileMenuOpen(false)}
              data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {link.label}
            </a>
          ))}
          <a href="#contact" onClick={() => setMobileMenuOpen(false)}>
            <Button className="bg-[#F59E0B] text-[#0A192F] font-bold px-8 py-3 rounded-none mt-4">
              Book a Lesson
            </Button>
          </a>
        </div>
      )}
    </header>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 hero-gradient" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
        {/* Grade A Badge */}
        <div className="inline-flex items-center gap-2 bg-[#F59E0B] text-[#0A192F] px-6 py-2 mb-6 font-bold text-sm animate-fadeInUp">
          <Award size={20} />
          <span>GRADE A DRIVING INSTRUCTOR</span>
        </div>
        
        {/* Brand Name */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-4 tracking-tight animate-fadeInUp stagger-1">
          Abbott Drives
        </h1>
        
        <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#F59E0B] mb-6 animate-fadeInUp stagger-2">
          Your Journey to Confident Driving Starts Here
        </p>
        
        <p className="text-lg md:text-xl text-slate-200 max-w-3xl mx-auto mb-10 animate-fadeInUp stagger-3">
          Professional, patient, and fully qualified driving instruction across 
          Slough, Windsor, Maidenhead & surrounding areas
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp stagger-4">
          <a href="#contact">
            <Button 
              className="bg-[#F59E0B] text-[#0A192F] hover:bg-[#D97706] hover:text-white font-bold px-8 py-6 text-lg rounded-none shadow-lg"
              data-testid="hero-book-btn"
            >
              Book Your First Lesson
              <ChevronRight className="ml-2" size={20} />
            </Button>
          </a>
          <a href="#pass-students">
            <Button 
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#0A192F] font-bold px-8 py-6 text-lg rounded-none"
              data-testid="hero-pass-students-btn"
            >
              Our Success Stories
            </Button>
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full" />
        </div>
      </div>
    </section>
  );
};

// Why Choose Us Section
const WhyUsSection = () => {
  return (
    <section id="why-us" className="py-24 px-4 md:px-8 bg-[#F8FAFC]" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#F59E0B]">
            Why Choose Us
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A192F] mt-4 tracking-tight">
            Why Choose AbbottDrives?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {USPS.map((usp, index) => (
            <div
              key={index}
              className={`p-8 transition-all duration-300 card-hover ${
                usp.highlight 
                  ? 'grade-a-card col-span-1 md:col-span-2 lg:col-span-1' 
                  : 'bg-white border border-slate-200'
              }`}
              data-testid={`usp-card-${index}`}
            >
              <div className={`inline-flex items-center justify-center w-14 h-14 mb-6 ${
                usp.highlight ? 'bg-[#F59E0B]' : 'bg-[#0A192F]'
              }`}>
                <usp.icon className={usp.highlight ? 'text-[#0A192F]' : 'text-white'} size={28} />
              </div>
              <h3 className={`text-xl font-bold mb-3 ${usp.highlight ? 'text-[#F59E0B]' : 'text-[#0A192F]'}`}>
                {usp.title}
              </h3>
              <p className={usp.highlight ? 'text-slate-300' : 'text-slate-600'}>
                {usp.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section id="about" className="py-24 px-4 md:px-8 bg-white" data-testid="about-section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#F59E0B]">
            About Us
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A192F] mt-4 tracking-tight">
            Abbott Drives
          </h2>
        </div>
        
        <div className="space-y-6 text-slate-600 leading-relaxed text-lg text-center max-w-4xl mx-auto">
          <p>
            Abbott Drives isn't just about teaching people how to drive; it's about 
            empowering individuals with the confidence and skills they need to become safe, 
            responsible, and skilled drivers for life.
          </p>
          <p>
            Through personalised instruction and a commitment to excellence, we create a supportive 
            environment where learners of all levels thrive. From the fundamentals of driving to 
            advanced techniques, our curriculum is designed to instill not only the rules of the 
            road but also the critical thinking and decision-making abilities necessary for safe 
            driving in any situation.
          </p>
          <p className="font-semibold text-[#0A192F] text-xl">
            Join us at Abbott Drives and embark on your journey towards becoming a 
            confident and competent driver. Let's navigate the road together, safely and skillfully.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-8 justify-center">
          <div className="flex items-center gap-3 bg-[#F8FAFC] px-6 py-4">
            <Shield className="text-[#F59E0B]" size={28} />
            <span className="font-semibold text-[#0A192F]">DVSA Approved</span>
          </div>
          <div className="flex items-center gap-3 bg-[#F8FAFC] px-6 py-4">
            <UserCheck className="text-[#F59E0B]" size={28} />
            <span className="font-semibold text-[#0A192F]">Grade A Instructor</span>
          </div>
          <div className="flex items-center gap-3 bg-[#F8FAFC] px-6 py-4">
            <Award className="text-[#F59E0B]" size={28} />
            <span className="font-semibold text-[#0A192F]">10+ Years Experience</span>
          </div>
        </div>
      </div>
    </section>
  );
};

// Courses Section
const CoursesSection = () => {
  return (
    <section id="courses" className="py-24 px-4 md:px-8 bg-[#F8FAFC]" data-testid="courses-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#F59E0B]">
            Our Courses
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A192F] mt-4 tracking-tight">
            Courses & Pricing
          </h2>
          <p className="text-slate-600 mt-4 max-w-2xl mx-auto">
            Choose the learning package that suits you best. No hidden fees - we'll find an option that works for you.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {COURSES.map((course) => (
            <div
              key={course.id}
              className={`bg-white p-8 transition-all duration-300 card-hover ${
                course.popular ? 'pricing-popular' : 'border border-slate-200'
              }`}
              data-testid={`course-card-${course.id}`}
            >
              <h3 className="text-xl font-bold text-[#0A192F] mb-2">{course.title}</h3>
              <p className="text-slate-500 text-sm mb-6">{course.description}</p>
              
              <div className="mb-6">
                <span className="text-4xl font-black text-[#0A192F]">{course.price}</span>
                <span className="text-slate-500 ml-2">/ {course.unit}</span>
              </div>

              <ul className="space-y-3 mb-8">
                {course.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <CheckCircle className="text-[#10B981] flex-shrink-0 mt-0.5" size={18} />
                    <span className="text-slate-600 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <a href="#contact">
                <Button 
                  className={`w-full rounded-none font-bold py-6 ${
                    course.popular 
                      ? 'bg-[#F59E0B] text-[#0A192F] hover:bg-[#D97706] hover:text-white' 
                      : 'bg-[#0A192F] text-white hover:bg-[#1E3A8A]'
                  }`}
                  data-testid={`course-book-btn-${course.id}`}
                >
                  Get Started
                </Button>
              </a>
            </div>
          ))}
        </div>

        {/* Pass Plus Note */}
        <div className="mt-12 bg-[#0A192F] p-8 text-center">
          <GraduationCap className="mx-auto text-[#F59E0B] mb-4" size={40} />
          <h3 className="text-xl font-bold text-white mb-3">Pass Plus Scheme</h3>
          <p className="text-slate-300 max-w-2xl mx-auto">
            Enhance your driving with Pass Plus, potentially saving money on insurance and ensuring 
            safer journeys. Particularly beneficial for younger drivers facing high insurance costs.
          </p>
        </div>
      </div>
    </section>
  );
};

// Areas Section
const AreasSection = () => {
  return (
    <section id="areas" className="py-24 px-4 md:px-8 bg-white" data-testid="areas-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#F59E0B]">
            Coverage Area
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A192F] mt-4 tracking-tight">
            Areas We Cover
          </h2>
          <p className="text-slate-600 mt-4">All SL postcodes covered</p>
        </div>

        <div className="flex flex-wrap justify-center gap-4">
          {AREAS.map((area, index) => (
            <div
              key={index}
              className="area-badge flex items-center gap-3 cursor-default"
              data-testid={`area-badge-${index}`}
            >
              <MapPin className="text-[#F59E0B]" size={20} />
              <span className="text-[#0A192F]">{area}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-500">
            Don't see your area? <a href="#contact" className="text-[#F59E0B] font-semibold hover:underline">Contact us</a> to check availability.
          </p>
        </div>
      </div>
    </section>
  );
};

// Pass Students Section
const PassStudentsSection = () => {
  // All 12 real student photos
  const allStudents = PASS_STUDENTS;

  return (
    <section 
      id="pass-students" 
      className="py-24 px-4 md:px-8 relative overflow-hidden"
      style={{ 
        background: `linear-gradient(rgba(248, 250, 252, 0.95), rgba(248, 250, 252, 0.95)), url(${CONFETTI_BG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      data-testid="pass-students-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Celebratory Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-[#10B981] to-[#059669] text-white px-8 py-3 mb-6">
            <Sparkles size={24} />
            <span className="font-bold text-lg">Congratulations to All!</span>
            <Sparkles size={24} />
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A192F] tracking-tight">
            Our Proud Pass Students
          </h2>
          <p className="text-slate-600 mt-4 text-lg">
            These are some of the students that have passed with us — we couldn't be prouder!
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {allStudents.map((student, index) => (
            <div
              key={student.id}
              className="pass-card bg-white overflow-hidden shadow-lg"
              data-testid={`pass-student-${index}`}
            >
              {student.image ? (
                <>
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img 
                      src={student.image} 
                      alt={student.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="pass-badge">
                      PASSED! <CheckCircle size={14} className="inline ml-1" />
                    </div>
                  </div>
                </>
              ) : (
                <div className="aspect-[3/4] border-2 border-dashed border-slate-300 flex items-center justify-center bg-slate-50">
                  <div className="text-center text-slate-400 p-4">
                    <Users size={40} className="mx-auto mb-2" />
                    <p className="text-sm font-medium">[STUDENT PHOTO {index + 1}]</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-xl text-[#0A192F] font-semibold mb-6">
            Could this be you next? Book your first lesson today!
          </p>
          <a href="#contact">
            <Button 
              className="bg-[#10B981] text-white hover:bg-[#059669] font-bold px-8 py-6 text-lg rounded-none"
              data-testid="pass-students-cta"
            >
              Start Your Journey
              <ChevronRight className="ml-2" size={20} />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

// Testimonials Section
const TestimonialsSection = ({ reviews }) => {
  const allTestimonials = [...TESTIMONIALS, ...(Array.isArray(reviews) ? reviews : []).map((r, i) => ({
    id: `review-${i}`,
    name: r.name,
    text: r.review_text,
    rating: r.rating
  }))];

  return (
    <section id="testimonials" className="py-24 px-4 md:px-8 bg-[#0A192F]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#F59E0B]">
            Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4 tracking-tight">
            What Our Students Say
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {allTestimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="testimonial-card bg-white/10 backdrop-blur-sm p-8 border border-white/10"
              data-testid={`testimonial-${testimonial.id}`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-[#F59E0B] fill-[#F59E0B]" size={20} />
                ))}
              </div>
              
              <p className="text-slate-300 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#F59E0B] rounded-full flex items-center justify-center">
                  <span className="text-[#0A192F] font-bold">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <span className="text-white font-semibold">{testimonial.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = ({ onSubmitContact }) => {
  const [contactForm, setContactForm] = useState({
    name: '', phone: '', email: '', message: '', lesson_type: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!contactForm.name || !contactForm.phone || !contactForm.email || !contactForm.lesson_type) {
      toast.error("Please fill in all required fields");
      return;
    }
    setSubmitting(true);
    await onSubmitContact(contactForm);
    setContactForm({ name: '', phone: '', email: '', message: '', lesson_type: '' });
    setSubmitting(false);
  };

  return (
    <section id="contact" className="py-24 px-4 md:px-8 bg-[#F8FAFC]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#F59E0B]">
            Get In Touch
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A192F] mt-4 tracking-tight">
            Contact Us
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-[#0A192F] p-8 md:p-12">
            <h3 className="text-2xl font-bold text-white mb-8">Book a Lesson</h3>
            
            <form onSubmit={handleContactSubmit} className="space-y-6">
              <div>
                <Input
                  type="text"
                  placeholder="Your Name *"
                  value={contactForm.name}
                  onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                  className="rounded-none border-slate-600 bg-slate-800 text-white placeholder:text-slate-400 focus:border-[#F59E0B] h-12"
                  style={{ color: 'white' }}
                  data-testid="contact-name-input"
                />
              </div>
              <div>
                <Input
                  type="tel"
                  placeholder="Phone Number *"
                  value={contactForm.phone}
                  onChange={(e) => setContactForm({...contactForm, phone: e.target.value})}
                  className="rounded-none border-slate-600 bg-slate-800 text-white placeholder:text-slate-400 focus:border-[#F59E0B] h-12"
                  style={{ color: 'white' }}
                  data-testid="contact-phone-input"
                />
              </div>
              <div>
                <Input
                  type="email"
                  placeholder="Email Address *"
                  value={contactForm.email}
                  onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                  className="rounded-none border-slate-600 bg-slate-800 text-white placeholder:text-slate-400 focus:border-[#F59E0B] h-12"
                  style={{ color: 'white' }}
                  data-testid="contact-email-input"
                />
              </div>
              <div>
                <Select 
                  value={contactForm.lesson_type} 
                  onValueChange={(value) => setContactForm({...contactForm, lesson_type: value})}
                >
                  <SelectTrigger 
                    className="rounded-none border-slate-600 bg-slate-800 text-white focus:border-[#F59E0B] h-12"
                    style={{ color: 'white' }}
                    data-testid="contact-lesson-type-select"
                  >
                    <SelectValue placeholder="Preferred Lesson Type *" className="text-slate-400" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="single">Single Lesson</SelectItem>
                    <SelectItem value="block">Block Booking (10 hours)</SelectItem>
                    <SelectItem value="intensive">Intensive Course</SelectItem>
                    <SelectItem value="passplus">Pass Plus</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Textarea
                  placeholder="Your Message (Optional)"
                  value={contactForm.message}
                  onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                  className="rounded-none border-slate-600 bg-slate-800 text-white placeholder:text-slate-400 focus:border-[#F59E0B] min-h-[120px]"
                  style={{ color: 'white' }}
                  data-testid="contact-message-input"
                />
              </div>
              <Button 
                type="submit"
                disabled={submitting}
                className="w-full bg-[#F59E0B] text-[#0A192F] hover:bg-[#D97706] hover:text-white font-bold py-6 rounded-none"
                data-testid="contact-submit-btn"
              >
                {submitting ? 'Sending...' : 'Send Message'}
                <Send className="ml-2" size={20} />
              </Button>
            </form>
          </div>

          {/* Contact Info & Review Form */}
          <div className="space-y-8">
            {/* Contact Info */}
            <div className="bg-white p-8 border border-slate-200">
              <h3 className="text-2xl font-bold text-[#0A192F] mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <a 
                  href="tel:07877649536" 
                  className="flex items-center gap-4 text-slate-600 hover:text-[#F59E0B] transition-colors"
                  data-testid="contact-phone-link"
                >
                  <div className="w-12 h-12 bg-[#F8FAFC] flex items-center justify-center">
                    <Phone className="text-[#F59E0B]" size={24} />
                  </div>
                  <div>
                    <div className="text-sm text-slate-500">Phone</div>
                    <div className="font-semibold text-[#0A192F]">07877 649 536</div>
                  </div>
                </a>

                <a 
                  href="mailto:abbottdrives@gmail.com" 
                  className="flex items-center gap-4 text-slate-600 hover:text-[#F59E0B] transition-colors"
                  data-testid="contact-email-link"
                >
                  <div className="w-12 h-12 bg-[#F8FAFC] flex items-center justify-center">
                    <Mail className="text-[#F59E0B]" size={24} />
                  </div>
                  <div>
                    <div className="text-sm text-slate-500">Email</div>
                    <div className="font-semibold text-[#0A192F]">abbottdrives@gmail.com</div>
                  </div>
                </a>

                <a 
                  href="https://wa.me/447877649536"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 bg-[#25D366] text-white p-4 hover:bg-[#128C7E] transition-colors"
                  data-testid="contact-whatsapp-link"
                >
                  <MessageCircle size={28} />
                  <span className="font-bold">Chat with us on WhatsApp</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="bg-[#0A192F] py-16 px-4 md:px-8" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Abbott Drives" 
              className="h-24 w-auto mb-6 bg-white p-2"
            />
            <p className="text-slate-400 max-w-md">
              Professional driving instruction with a Grade A instructor. 
              Building confident, safe drivers across Slough, Windsor, Maidenhead and surrounding areas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {NAV_LINKS.slice(0, 5).map((link) => (
                <li key={link.href}>
                  <a 
                    href={link.href} 
                    className="text-slate-400 hover:text-[#F59E0B] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:07877649536" className="text-slate-400 hover:text-[#F59E0B] flex items-center gap-3">
                  <Phone size={18} />
                  07877 649 536
                </a>
              </li>
              <li>
                <a href="mailto:abbottdrives@gmail.com" className="text-slate-400 hover:text-[#F59E0B] flex items-center gap-3">
                  <Mail size={18} />
                  Email Us
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/447877649536" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-[#25D366] flex items-center gap-3"
                >
                  <MessageCircle size={18} />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              &copy; {new Date().getFullYear()} Abbott Drives. All rights reserved.
            </p>
            <div className="flex items-center gap-2">
              <Award className="text-[#F59E0B]" size={20} />
              <span className="text-slate-400 text-sm">Grade A DVSA Approved Instructor</span>
            </div>
          </div>
          {/* Created by credit */}
          <div className="text-center mt-6 pt-6 border-t border-slate-800">
            <p className="text-slate-500 text-sm">
              Website created by{' '}
              <a 
                href="https://www.wktechexpert.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#F59E0B] hover:text-[#D97706] transition-colors font-medium"
              >
                WK Tech Expert
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

// WhatsApp FAB
const WhatsAppFAB = () => {
  return (
    <a
      href="https://wa.me/447877649536"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab whatsapp-pulse"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
};

// Main App
function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Fetch reviews
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${API}/reviews`);
        setReviews(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      }
    };
    fetchReviews();

    // Intersection Observer for section animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('section').forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const handleContactSubmit = async (formData) => {
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Thank you! We'll be in touch soon.");
    } catch (error) {
      console.error('Error submitting contact form:', error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <Header 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen} 
      />
      <main>
        <HeroSection />
        <WhyUsSection />
        <AboutSection />
        <AreasSection />
        <PassStudentsSection />
        <TestimonialsSection reviews={reviews} />
        <ContactSection 
          onSubmitContact={handleContactSubmit} 
        />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}

export default App;
